<div class="status-msg-container" *ngIf="requestFailed()">
    <div class="status">
      <p>{{errorMessage}}</p>
      <div class="icon">
        <mat-icon class="sub--icon error-color">highlight_off</mat-icon>
      </div>
      <p class="error">{{errorDescription}}</p>
    </div>
  </div>
  <!-- Details of success -->
  <div class="status-msg-container" *ngIf="!requestFailed()">
    <div class="status">
      <p>{{successMessage}}</p>
      <div class="icon">
        <mat-icon class="sub--icon success-color">check_circle_outline</mat-icon>
      </div>
      <p class="success">You can now close the wizard</p>
    </div>
  </div>